<template>
	<section class="mobile py-5 bg-success text-white">
		<div class="container">
			<div class="mobile-top text-center mb-5">
				<h1 class="text-white">HVI Mobile App Now Available!</h1>
			</div>
			<div class="row ">
				<div class="col-md-4 text-center text-md-left">
					<img src="https://hviorder.ca/img/phones.png" class="">
				</div>
				<div class="col-md-8 pt-5">
					<p class="mb-5">HVI Mobile lets you place appraisal orders on the go using your mobile
						smartphone. It includes the essential functionality of this website, but
						optimized for your mobile device. With HVI Mobile, you can quickly place
						an order or check the status of any existing ones. Download and start
						using today!</p>
					<div class="mobile-buttons text-center text-md-left">
						<button class="btn btn-dark btn-lg mr-3">App Store</button>
						<button class="btn btn-dark btn-lg">Google Play</button>
					</div>
				</div>
			</div>
		</div>
	
	</section>
</template>

<script>
	export default {
		name: 'Mobile',
		data () {
			return {}
		}
	}
</script>
